import React from "react";

/**
 * ScrollArea Component
 * 
 * A container component that enables scrolling for its content.
 * 
 * @component
 * @example
 * <ScrollArea className="h-[200px]">
 *   Long content...
 * </ScrollArea>
 */
export const ScrollArea = React.forwardRef(({ children, className = "" }, ref) => {
  return (
    <div ref={ref} className={`overflow-auto ${className}`}>
      {children}
    </div>
  );
});